import React from 'react';
import {connect} from 'react-redux';
import {useDropzone} from 'react-dropzone';

import {ImageService} from '../Services/ImageService';
import {AppState} from '../Store';
import {useOnDrop} from '../Shared/useOnDrop';

interface ImageUploadProps {
  id: number;
  onUpload: (id: number) => void;

  getLink: (id: number) => string;
  imageService: ImageService;
}

function ImageUpload({id, onUpload, getLink, imageService}: ImageUploadProps) {
  const onDrop = useOnDrop(imageService, onUpload);
  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    accept: 'image/*',
    multiple: false,
  });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <img src={getLink(id)} alt={id.toString()} />
      {
        isDragActive ?
          <p>Drop it here</p> :
          <p>Drop an image here or click to select</p>
      }
    </div>
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    getLink: state.auth.imageService.link,
    imageService: state.auth.imageService,
  };
};

export default connect(mapStateToProps)(ImageUpload);
